var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsHelpIcon = function SvgDsHelpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.629 6.221a.667.667 0 0 1-1.261-.433L6 6l-.632-.212v-.003l.002-.004.003-.009a1 1 0 0 1 .037-.093q.035-.084.105-.212c.094-.168.241-.387.46-.606C6.427 4.411 7.151 4 8.231 4c1.18 0 2.136.749 2.378 1.794.249 1.076-.296 2.227-1.59 3l-.022.014-.023.01c-.082.042-.523.38-.523 1.182a.667.667 0 0 1-1.333 0c0-1.308.722-2.091 1.234-2.36.92-.557 1.043-1.179.958-1.545-.093-.4-.476-.762-1.08-.762-.704 0-1.096.256-1.313.473a1.4 1.4 0 0 0-.288.415M8 12.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.667 8a7.333 7.333 0 1 1 14.666 0A7.333 7.333 0 0 1 .667 8M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2",
    clipRule: "evenodd"
  })));
};
export default SvgDsHelpIcon;